import * as React from 'react';
import { connect } from 'react-redux';

import { IExperiment } from '../../api/experiments';
import { IState } from '../../store';
import { isLeadFactory } from '../../utils/agent';
import { EGroup, getGroup } from '../utils';
import { PopupWithComplaint } from './PopupWithComplaint';
import { PopupWithForm } from './PopupWithForm';
import { WhereYouFindOfferText } from './WhereYouFindOfferText';

export interface IFeedbackExperimentProps {
  experiments: IExperiment[];
  isLeadFactory?: boolean;
}

export function FeedbackExperiment({ experiments, isLeadFactory }: IFeedbackExperimentProps) {
  const group = getGroup(experiments);

  if (isLeadFactory) {
    switch (group) {
      case EGroup.bGroup:
        return <PopupWithForm />;
      case EGroup.cGroup:
        return <PopupWithComplaint />;
      default:
        return null;
    }
  }

  switch (group) {
    case EGroup.aGroup:
      return <WhereYouFindOfferText />;
    case EGroup.bGroup:
      return <PopupWithForm />;
    case EGroup.cGroup:
      return <PopupWithComplaint />;
    default:
      return <WhereYouFindOfferText />;
  }
}

export function mapStateToProps(state: IState) {
  return {
    experiments: state.experiments,
    isLeadFactory: isLeadFactory(state.offerData.offer),
  };
}

export const FeedbackExperimentContainer = connect(mapStateToProps)(FeedbackExperiment);
